module.exports = __webpack_public_path__ + "img/l-12.4549b527.png";